module.exports = "<button class=\"btn btn-default\" [disabled]=\"isDisabled\">\n    <span *ngIf=\"status==='SUBSCRIBED'\">\n    <i class=\"fa fa-envelope-o color-icon\" style=\"position: relative\">\n        <i class=\"fa fa-ban color-icon icon-ban-unsubscribe\"></i>\n    </i>\n    </span>\n    <i class=\"fa fa-envelope-o color-icon\" *ngIf=\"status==='UNSUBSCRIBED'\"></i>\n       {{ btnText }}\n</button>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.html
// module id = ./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.html
// module chunks = 0